import * as api from './main'

export const mainApi = api
